module.exports = __webpack_public_path__ + "media/images/truck-126d78f59d34f8db179b64670fa00ee0.png";